module.exports = __webpack_public_path__ + "static/media/banner-mobile.a52d530b.png";